import React, { useState } from 'react'
import { TextInput, Legend } from '../../ui/form'

import { tips } from '../locales'
import storage from '../utils/storage'
import './styles.scss'
import { CheckoutSettings } from '../request/apis'

const PO_NUMBER = 'b3-po-number'

const PoNumber = (props: { checkoutSettings: CheckoutSettings }) => {
  const {
    checkoutSettings: {
      checkoutPaymentPurchaseExtraFields,
      checkoutPaymentPurchaseExtraFieldsRequired,
    },
  } = props

  const [poNumber, setPoNumber] = useState(storage.B3PoNumber.getValue() || '')

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    setPoNumber(val)
    val ? storage.B3PoNumber.setValue(val) : storage.B3PoNumber.removeValue()
  }

  return (
    <div className="b3-po-container" >
      <Legend className="inner-po-label">
        <label htmlFor={PO_NUMBER}>
          <span> {checkoutPaymentPurchaseExtraFields?.value} </span>
          {
            +checkoutPaymentPurchaseExtraFieldsRequired.value === 0 &&
            <span>{tips['b3.label.optional']}</span>
          }
        </label>
      </Legend>
      <TextInput
        id={PO_NUMBER}
        name={PO_NUMBER}
        value={poNumber}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default PoNumber